import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { moment } from '../../util/date'
import TimeSelector from '../time-selector/time-selector'
import * as customPropTypes from './prop-types'

import styles from './time-input.module.css'

const propTypes = {
    allowEmpty: PropTypes.bool,
    dateValue: PropTypes.oneOfType([PropTypes.instanceOf(moment)]),
    error: PropTypes.instanceOf(Error),
    intl: customPropTypes.intl.isRequired,
    onChange: PropTypes.func.isRequired,
    timeValue: PropTypes.string.isRequired
}

function TimeInput({ allowEmpty, dateValue, error, intl, onChange, timeValue }) {
    const date = dateValue ? intl.formatDateOnly(dateValue) : '-'

    return (
        <div className={styles.time}>
            <span className={cx('t3sel-time-label', styles['time-label'])}>{date}</span>
            <TimeSelector value={timeValue} {...{ allowEmpty, error, onChange }} />
        </div>
    )
}

TimeInput.propTypes = propTypes

export default TimeInput
